import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Documento } from '../_model/documento';

const pathApi = 'Documento';

@Injectable({
    providedIn: 'root',
})
export class DocumentoService {

    constructor(private http: HttpClient) { }

    getDocumentos(codigos: string[]): Observable<Documento[]> {
        return this.http.post<Documento[]>(`${environment.URL_API}/${pathApi}`, codigos);
    }
}